if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.querySelector('.product-media-modal__nav--prev')?.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showPreviousMedia();
          }
        );

        this.querySelector('.product-media-modal__nav--next')?.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showNextMedia();
          }
        );

        document.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            this.showPreviousMedia();
          }

          if (event.key === 'ArrowRight') {
            this.showNextMedia();
          }
        });

        this.touchStartX = 0;
        this.touchEndX = 0;

        this.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0].screenX;
        });

        this.addEventListener('touchend', (event) => {
          this.touchEndX = event.changedTouches[0].screenX;
          this.handleSwipe();
        });

        this.addEventListener('click', (event) => {

          if (
            event.target.closest('.product-media-modal__content') ||
            event.target.closest('.product-media-modal__toggle') ||
            event.target.closest('.product-media-modal__nav')
          ) {
            return;
          }

          this.hide();
        });

      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.style.opacity = '1';
        this.positionControls();
        const items = this.getMediaItems();
        const activeIndex = items.findIndex(
          (item) => item.getAttribute('data-media-id') === activeMedia.getAttribute('data-media-id')
        );

        this.updateCounter(activeIndex);
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      updateCounter(index) {
        const current = this.querySelector('.product-media-modal__current');

        if (current) {
          current.textContent = index + 1;
        }
      }

      positionControls() {
        const activeMedia = this.querySelector('[data-media-id].active');

        const closeButton = this.querySelector('.product-media-modal__toggle');
        const prevButton = this.querySelector('.product-media-modal__nav--prev');
        const nextButton = this.querySelector('.product-media-modal__nav--next');
        const counter = this.querySelector('.product-media-modal__counter');

        if (!activeMedia) return;

        const rect = activeMedia.getBoundingClientRect();
        const centerY = rect.top + rect.height / 2;

        if (closeButton) {
          closeButton.style.left = `${rect.right - 16}px`;
          closeButton.style.top = `${rect.top - 16}px`;
          closeButton.style.right = 'auto';
        }

        if (window.innerWidth <= 989) {

          if (prevButton) {
            prevButton.style.left = `${rect.left + rect.width / 2}px`;
            prevButton.style.top = `${rect.top - 10}px`;
            prevButton.style.transform = 'translate(-50%, -50%)';
          }

          if (nextButton) {
            nextButton.style.left = `${rect.left + rect.width / 2}px`;
            nextButton.style.top = `${rect.bottom + 10}px`;
            nextButton.style.transform = 'translate(-50%, -50%)';
          }

        } else {

          if (prevButton) {
            prevButton.style.left = `${rect.left - 30}px`;
            prevButton.style.top = `${centerY}px`;
            prevButton.style.transform = 'translateY(-50%)';
          }

          if (nextButton) {
            nextButton.style.left = `${rect.right - 10}px`;
            nextButton.style.top = `${centerY}px`;
            nextButton.style.transform = 'translateY(-50%)';
          }

        }

        if (counter) {
          counter.style.left = `${rect.left + rect.width / 2}px`;
          counter.style.top = `${rect.bottom - 35}px`;
          counter.style.bottom = 'auto';
          counter.style.transform = 'translateX(-50%)';
        }

      }

      handleSwipe() {
        const swipeDistance = this.touchEndX - this.touchStartX;

        if (Math.abs(swipeDistance) < 50) return;

        if (swipeDistance > 0) {
          this.showPreviousMedia();
        } else {
          this.showNextMedia();
        }
      }

      showPreviousMedia() {
        const items = this.getMediaItems();
        const currentIndex = items.findIndex((item) =>
          item.classList.contains('active')
        );

        const newIndex =
          currentIndex === 0
            ? items.length - 1
            : currentIndex - 1;

        items[currentIndex].style.opacity = '0';

        setTimeout(() => {
          items[currentIndex].classList.remove('active');

          items[newIndex].classList.add('active');
          items[newIndex].style.opacity = '0';

          requestAnimationFrame(() => {
            items[newIndex].style.opacity = '1';
          });

          this.updateCounter(newIndex);
          this.positionControls();
        }, 150);
      }

      showNextMedia() {
        const items = this.getMediaItems();
        const currentIndex = items.findIndex((item) =>
          item.classList.contains('active')
        );

        const newIndex =
          currentIndex === items.length - 1
            ? 0
            : currentIndex + 1;

        items[currentIndex].style.opacity = '0';

        setTimeout(() => {
          items[currentIndex].classList.remove('active');

          items[newIndex].classList.add('active');
          items[newIndex].style.opacity = '0';

          requestAnimationFrame(() => {
            items[newIndex].style.opacity = '1';
          });

          this.updateCounter(newIndex);

          if (items[newIndex].complete) {
            this.positionControls();
          } else {
            items[newIndex].addEventListener(
              'load',
              () => this.positionControls(),
              { once: true }
            );
          }
        }, 150);
      }

    }
  );
}
